import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import { DragDropContext as dragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import { AutoSizer } from 'react-virtualized'

import { gridLoadEventGroup } from 'actions/grid'
import { getIsLoading, getIsSaving } from 'selectors/grid'

import Grid from 'components/grid'
import GridSidebar from 'components/grid-sidebar'
import GridHeader from 'components/grid-header'
import GridDatesModal from 'components/grid-dates-modal'
import GridErrorModal from 'components/grid-error-modal'
import GridTicketModal from 'components/grid-ticket-modal'
import LoadingSpinner from 'components/loading-spinner'

import styles from './event-group-grid-page.css'

export class EventGroupGridPage extends Component {

  componentWillMount() {
    this.props.gridLoadEventGroup(this.props.eventGroupId)
  }

  render() {
    return (
      <div styleName="container">
        <div styleName="header">
          <GridHeader eventGroupId={this.props.eventGroupId}>
            Edit dates, times and tickets
          </GridHeader>
        </div>

        <div styleName="content">
          <GridSidebar />
          <div styleName="autosize-container">
            <AutoSizer>
              {({ height, width }) => (
                <Grid
                  width={width}
                  height={height}
                  cellWidth={260}
                  headerHeight={120}
                  leftHeaderCellWidth={160}
                />
              )}
            </AutoSizer>
          </div>
        </div>

        <GridErrorModal />
        <GridDatesModal />
        <GridTicketModal {...this.props} />
        {(this.props.isLoading || this.props.isSaving) && <div styleName="loading"><LoadingSpinner /></div>}
      </div>
    )
  }
}

EventGroupGridPage.propTypes = {
  eventGroupId: PropTypes.number.isRequired,
  gridLoadEventGroup: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
}

const mapStateToProps = (state, ownProps) => ({
  eventGroupId: parseInt(ownProps.params.eventGroupId, 10),
  isLoading: getIsLoading(state),
  isSaving: getIsSaving(state),
})

const mapDispatchToProps = {
  gridLoadEventGroup,
}

const DNDEventGroupGridPage = dragDropContext(HTML5Backend)(CSSModules(EventGroupGridPage, styles))
export default connect(mapStateToProps, mapDispatchToProps)(DNDEventGroupGridPage)



/** WEBPACK FOOTER **
 ** ./src/containers/event-group-grid-page/event-group-grid-page.js
 **/